import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { withTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import IframeLauncher from "./IframeLauncher";
import axios from "axios";
import arrows from "../../../src/assets/images/mo_icon/mo_arrow_left.svg";
import ListIcon from "../../../src/assets/images/icons/view_button.svg";
import GirdIcon from "../../../src/assets/images/icons/grid_view.svg";
import SearchIcon from "../../../src/assets/images/icons/search.svg";
import bg12 from "../../../src/assets/images/game_bg/dingdong-12.png";
import bg12new from "../../../src/assets/images/game_bg/dingdong-12-NEW.png";
import bg24 from "../../../src/assets/images/game_bg/dingdong-24.png";
import bg24new from "../../../src/assets/images/game_bg/dingdong-24-NEW.png";
import bg48 from "../../../src/assets/images/game_bg/dingdong-48.png";
import bg48new from "../../../src/assets/images/game_bg/dingdong-48-NEW.png";
import bg36 from "../../../src/assets/images/game_bg/dingdong-36.png";
import bg36new from "../../../src/assets/images/game_bg/dingdong-36-NEW.png";
import bgdt from "../../../src/assets/images/game_bg/dragon-tiger.svg";
import goldRush from "../../../src/assets/images/game_bg/gold-rush.png";
import bgcrash from "../../../src/assets/images/game_bg/bgcrash.png";
import bgdice from "../../../src/assets/images/game_bg/bgdice.png";
import bghilo from "../../../src/assets/images/game_bg/bghilo.png";
import bgpyramid from "../../../src/assets/images/game_bg/bgpyramid.png";
import bgpd from "../../../src/assets/images/game_bg/pocker-dice.png";
import bgpdnew from "../../../src/assets/images/game_bg/poker-dice-new.png";
import bgsicbo from "../../../src/assets/images/game_bg/sicbo.png";
import bgsicbonew from "../../../src/assets/images/game_bg/sicbo-NEW.png";
import bgsw from "../../../src/assets/images/game_bg/super-wheel.png";
import L48D from "../../../src/assets/images/game_logo/Icon_48D.svg";
import L36D from "../../../src/assets/images/game_logo/Icon-36D.svg";
import L24D from "../../../src/assets/images/game_logo/Icon-24D.svg";
import L12D from "../../../src/assets/images/game_logo/Icon_12D.svg";
import LdragonTiger from "../../../src/assets/images/game_logo/Icon-DragonTiger.svg";
import LpockerDice from "../../../src/assets/images/game_logo/heart.svg";
import SciboLogo from "../../../src/assets/images/game_logo/sicboLogo.svg";
import SuperWheel from "../../../src/assets/images/game_logo/super_wheel.svg";
import goldRushLogo from "../../../src/assets/images/game_logo/gold_rush.svg";
import allgame from "../../assets/images/mo_icon/mo_allgame_button-01.svg";
import UserIcon from "../../../src/assets/images/icons/user_white.svg";
import CloseIcon from "../../assets/images/icons/close_icon.svg";
import FestiveThemeGameImg from "../../assets/images/FestiveTheme/snow-for-tiles.svg";
import NewYearThemeImg from "../../assets/images/FestiveTheme/theme2/Desktop/flowers_for_tiles.svg";
import NewYearThemeMobileImg from "../../assets/images/FestiveTheme/theme2/Mobile/flowers_for_tiles_mobile_portrait.svg";
import RamadanThemeImg from "../../assets/images/FestiveTheme/RamadanTheme/game_rit_top.svg";
import Tower from "../../../src/assets/images/game_bg/Tower.jpg";
import keno from "../../../src/assets/images/game_bg/keno.jpg";
import keno_coin from "../../../src/assets/images/game_bg/keno_coin.jpg";
import BB_cross from "../../../src/assets/images/game_bg/BB_cross.jpg";

import {
  makeAjax,
  respStatus,
  showMessage,
  socket,
  url,
} from "../../helpers/global_helper";

import NumberResult from "./ResultComponent/NumberResult";
import TabularResult from "./ResultComponent/TabularResult";
import DiceResult from "./ResultComponent/DiceResult";
import dummyimg from "../../assets/images/all/maintaince.svg";
import PockerDice from "./ResultComponent/PockerDice";
import SuperWheelResult from "./ResultComponent/SuperWheelResult";
import Dingdong48D_STD from "../../assets/images/Model/48D-standard.png";
import Dingdong48D_NEW from "../../assets/images/Model/48D_new.png";
import Dingdong12D_NEW from "../../assets/images/Model/12D-new.png";
import Dingdong24D_NEW from "../../assets/images/Model/24D-new.png";
import Dingdong36D_NEW from "../../assets/images/Model/36D-new.png";

import Dingdong48D_VIP from "../../assets/images/Model/48D-vip.png";
import Dingdong48D_PRE from "../../assets/images/Model/48D-president.png";
import Dingdong36D_STD from "../../assets/images/Model/36D-standard.png";
import Dingdong36D_VIP from "../../assets/images/Model/36D-vip.png";
import Dingdong36D_PRE from "../../assets/images/Model/36D-president.png";
import Dingdong24D_STD from "../../assets/images/Model/24D-standard.png";
import Dingdong24D_VIP from "../../assets/images/Model/24D-vip.png";
import Dingdong24D_PRE from "../../assets/images/Model/24D-president.png";
import Dingdong12D_STD from "../../assets/images/Model/12D-standard.png";
import Dingdong12D_VIP from "../../assets/images/Model/12D-vip.png";
import Dingdong12D_PRE from "../../assets/images/Model/12D-president.png";
import Sicbo_STD from "../../assets/images/Model/sicbo-standard.png";
import Sicbo_VIP from "../../assets/images/Model/sicbo-vip.png";
import Sicbo_PRE from "../../assets/images/Model/sicbo-president.png";
import Sicbo_NEW from "../../assets/images/Model/sicbo-new.png";
import PokerDice_STD from "../../assets/images/Model/poker-dice-standard.png";
import PokerDice_VIP from "../../assets/images/Model/paker-dice-vip.png";
import PokerDice_PRE from "../../assets/images/Model/poker-dice-president.png";
import PokerDice_NEW from "../../assets/images/Model/poker-dice-new.png";
import DragonTiger_STD from "../../assets/images/Model/dragon-tiger-standard.png";
import DragonTiger_VIP from "../../assets/images/Model/dragon-tiger-vip.png";
import DragonTiger_PRE from "../../assets/images/Model/dragon-tiger-president.png";
import SuperWheel_VIP from "../../assets/images/Model/super-wheel-standard.png";
import GoldRushModal from "../../assets/images/Model/gold-rush-logo.png";
import Bonus from "../Bonus/Bonus";
import CoachMarkPopup from "../Modal/CoachMarkPopup";
import { setCommonConfig, setCurrentStep } from "../../redux/actions";
import GrhResult from "./ResultComponent/GrhResult";
import Promotion from "../Promotion/Promotion";

const LobbyContent = (props) => {
  const navigate = useNavigate();
  const device = useSelector((state) => state.CommonConfig.device_type);
  const PromoStatus = useSelector((state) => state.CommonConfig.promoStatus);

  const [showIframe, setShowIframe] = useState(false);
  const [iframeUrl, setIframeUrl] = useState("");
  const [isLaunching, setIsLaunching] = useState(false);

  const [showPromoPopup, setShowPromoPopup] = useState(false);
  const [bannerImg, setBannerImg] = useState('');
  const [bannerId, setBannerId] = useState('');

  const [flagHomepopup, setFlagHomepopup] = useState('');
  const [flagPromotionMenu, setFlagPromotionMenu] = useState('');
  const [urlHomepopup, setUrlHomepopup] = useState('');

  const [selectedBanner, setSelectedBanner] = useState(null);
  const [showPromotion, setShowPromotion] = useState(false);
  const [doNotShowAgain, setDoNotShowAgain] = useState(false);
  const userName = useSelector((state => state.UserProfile.user_name));

  const handleLaunchGame = async (room, userName) => {
    const reqdatalg = {
      gameCode: room.game_code,
      roomId: room.room_id,
      user_name: userName,
    };

    try {
      setIsLaunching(true);
      const response = await makeAjax(url.ARCADE_API.launchGame, reqdatalg, url.ARCADE_MS_EXT);
      if (response.status === "SUCCESS") {
        setIframeUrl(response.data); // Assuming `response.data` contains the game URL
        setShowIframe(true);
      } else if (response.status === "ERROR") {
        showMessage(props.t(response.code), 'error', 'Error');
        return;
      } else {
        console.error("Failed to fetch game URL");
      }
    } catch (error) {
      console.error("Error launching game:", error);
    } finally {
      setIsLaunching(false);
    }
  };

  const handleCloseIframe = () => {
    setShowIframe(false);
    setIframeUrl("");
  };

  useEffect(() => {
    if (PromoStatus === 1) {
      const currentDate = new Date().toISOString().split("T")[0];

      makeAjax(url.PLAYER_API.getPromoBanner, { date: currentDate }, url.PLAYER_MS_EXT).then((response) => {
        if (response.status !== respStatus["SUCCESS"]) {
          showMessage(response);
          return;
        }

        const storedPreference = localStorage.getItem("promoPopupTimer");
        if (storedPreference) {
          let { expiration } = JSON.parse(storedPreference);

          if (new Date().getTime() > expiration) {
            localStorage.removeItem("promoPopupTimer");
            localStorage.removeItem("PopupIdArray");
          }
        }

        for (const element of response.data) {
          const parsedPopupIdArray = JSON.parse(localStorage.getItem("PopupIdArray")) || [];
          if (parsedPopupIdArray) {
            if (!parsedPopupIdArray.includes(element.id)) {
              // if (element.redirect_link === 'home' || element.redirect_link === 'promotion') {
              if (element.flag_homepopup === 1 || (element.flag_homepopup === 1 && element.flag_promotionmenu === 1)) {
                setShowPromoPopup(true);
                setBannerId(element.id);
                setBannerImg(element.updated_homepage_popup);
                setFlagHomepopup(element.flag_homepopup)
                setFlagPromotionMenu(element.flag_promotionmenu)
                setUrlHomepopup(element.url_homepopup)
                break;
              }
            }
          }
        }
        let PromoDirection = localStorage.getItem("PromoDirection");

        if (PromoDirection == 1 || window.location.pathname == '/') {
          handleClosePopup();
        }
      });
    }
  }, [PromoStatus]);

  const handleBannerClick = (e) => {
    if (flagHomepopup === 1 && urlHomepopup) {
      window.open(urlHomepopup, "_blank");
      return;
    }

    if (device === "Desktop") {
      if ((flagHomepopup === 1 || 0) && !urlHomepopup) {
        if (flagPromotionMenu === 1) {
          setShowPromotion(true);
          setShowPromoPopup(false);
          setSelectedBanner(bannerId); // ✅ store the clicked banner
          return;
        }
      }
    }

    if (device === "Mobile") {
      if ((flagHomepopup === 1 || flagHomepopup === 0) && !urlHomepopup) {
        if (flagPromotionMenu === 1) {
          setShowPromoPopup(false);
          localStorage.setItem('PromoDirection', 1);
          setTimeout(() => {
            navigate("/promotion", {
              state: {
                id: bannerId,
                activeState: activeState,
                // bannerData: banner,
              },
            });
          }, 0);
          return;
        }
      }
    }

    if (flagHomepopup === 0 && !urlHomepopup) {
      if (flagPromotionMenu === 0) {
        navigate("/");
        return;
      }
    }
  };

  const doNotChecked = (e) => {
    setDoNotShowAgain(e.target.checked);
  }

  const doNotShowChange = () => {
    dispatch(setCommonConfig({ key: 'promoStatus', value: 0 }))
    const newId = bannerId;
    setDoNotShowAgain(doNotShowAgain);
    if (doNotShowAgain) {
      let expiration = new Date().getTime() + 7 * 24 * 60 * 60 * 1000; // 7 days in milliseconds
      const existingExpiration = JSON.parse(localStorage.getItem("promoPopupTimer"));

      if (!existingExpiration) {
        localStorage.setItem(
          "promoPopupTimer",
          JSON.stringify({ expiration })
        );
      }

      const existingArray = JSON.parse(localStorage.getItem("PopupIdArray")) || [];
      // Check if the ID already exists to prevent duplicates
      if (!existingArray.includes(newId)) {
        existingArray.push(newId);
      }

      // Save the updated array back to localStorage
      localStorage.setItem("PopupIdArray", JSON.stringify(existingArray));
    }
  }


  const handleClosePopup = () => {
    setShowPromoPopup(false);
  };

  const gameIcon = {
    "48D": L48D,
    "48D -NEW": L48D,
    "36D": L36D,
    "24D": L24D,
    "12D": L12D,
    "36D -NEW": L36D,
    "24D -NEW": L24D,
    "12D -NEW": L12D,
    DT: LdragonTiger,
    PD: LpockerDice,
    "PD -NEW": LpockerDice,
    SB: SciboLogo,
    "SB -NEW": SciboLogo,
    WH: SuperWheel,
    GRH: goldRushLogo,

  };

  const modelImageMappings = {
    "Dingdong 48D-STANDARD": Dingdong48D_STD,
    "Dingdong 48D New-NEW": Dingdong48D_NEW,
    "Dingdong 24D New-NEW": Dingdong24D_NEW,
    "Dingdong 36D New-NEW": Dingdong36D_NEW,
    "Dingdong 12D New-NEW": Dingdong12D_NEW,
    "Gold Rush-Gold Rush": GoldRushModal,

    "Dingdong 48D-VIP": Dingdong48D_VIP,
    "Dingdong 48D-PRESIDENT": Dingdong48D_PRE,
    "Dingdong 36D-STANDARD": Dingdong36D_STD,
    "Dingdong 36D-VIP": Dingdong36D_VIP,
    "Dingdong 36D-PRESIDENT": Dingdong36D_PRE,
    "Dingdong 24D-STANDARD": Dingdong24D_STD,
    "Dingdong 24D-VIP": Dingdong24D_VIP,
    "Dingdong 24D-PRESIDENT": Dingdong24D_PRE,
    "Dingdong 12D-STANDARD": Dingdong12D_STD,
    "Dingdong 12D-VIP": Dingdong12D_VIP,
    "Dingdong 12D-PRESIDENT": Dingdong12D_PRE,
    "Sicbo-STANDARD": Sicbo_STD,
    "Sicbo-VIP": Sicbo_VIP,
    "Sicbo-PRESIDENT": Sicbo_PRE,
    "Sicbo NEW-NEW": Sicbo_NEW,
    "Poker Dice-STANDARD": PokerDice_STD,
    "Poker Dice-VIP": PokerDice_VIP,
    "Poker Dice -PRESIDENT": PokerDice_PRE,
    "Poker Dice NEW-NEW": PokerDice_NEW,
    "Dragon Tiger-STANDARD": DragonTiger_STD,
    "Dragon Tiger-VIP": DragonTiger_VIP,
    "Dragon Tiger-PRESIDENT": DragonTiger_PRE,
    "Super Wheel-STANDARD": SuperWheel_VIP,
  };

  const resultTemplate = {
    "48D": "number_result",
    "48D -NEW": "number_result",
    "12D -NEW": "number_result",
    "24D -NEW": "number_result",
    "36D -NEW": "number_result",
    "36D": "number_result",
    "24D": "number_result",
    "12D": "number_result",
    WH: "superwheel_result",
    // 'SB': 'tabular_result',
    // 'PD': 'dice_result',
    // 'DT': 'dice_result',
    SB: "dice_result",
    "SB -NEW": "dice_result",
    PD: "pockerdice_result",
    "PD -NEW": "pockerdice_result",
    DT: "tabular_result",
    GRH: "GRH_result",
  };

  const backgroundImage = {
    "48D": bg48,
    "48D -NEW": bg48new,
    "36D": bg36,
    "36D -NEW": bg36new,
    "24D": bg24,
    "24D -NEW": bg24new,
    "12D": bg12,
    "12D -NEW": bg12new,
    WH: bgsw,
    SB: bgsicbo,
    "SB -NEW": bgsicbonew,
    PD: bgpd,
    "PD -NEW": bgpdnew,
    DT: bgdt,
    GRH: goldRush,
    CRS: bgcrash,
    PPK: bgpyramid,
    DCE: bgdice,
    HLO: bghilo,
    TOR :Tower,
    KNO :keno,
    CFP :keno_coin,
    CSS :BB_cross,
  };

  const gameLabel = {
    WH: "Super Wheel",
    PD: "Poker Dice",
    "PD -NEW": "Poker Dice NEW",
    DT: "Dragon Tiger",
    SB: "Sicbo",
    "SB -NEW": "Sicbo NEW",
    GRH: "Gold Rush"

  };

  const gameHeading = {
    "AllGames": "All Games",
    "12D": "12D",
    "24D": "24D",
    "36D": "36D",
    "48D": "48D",
    "DT": "Dragon Tiger",
    "PD": "Poker Dice",
    "SB": "Sicbo",
    "SB -NEW": "Sicbo NEW",
    "WH": "Super Wheel",
    "MB": "Multi Bet",
    "ARCADE": "Arcade",
  }

  let tempLoading = 0;

  const renderSwitch = (template, game_code, room_id) => {
    switch (template) {
      case "number_result":
        return <NumberResult game_code={game_code} room_id={room_id} />;
      case "tabular_result":
        return <TabularResult game_code={game_code} room_id={room_id} />;
      case "dice_result":
        return <DiceResult game_code={game_code} room_id={room_id} />;
      case "pockerdice_result":
        return <PockerDice game_code={game_code} room_id={room_id} />;
      case "superwheel_result":
        return <SuperWheelResult game_code={game_code} room_id={room_id} />;
      case "GRH_result":
        return <GrhResult game_code={game_code} room_id={room_id} />;

    }
  };

  const user_profile = useSelector(state => state.UserProfile);
  const { game_code } = useParams();
  const dispatch = useDispatch();
  const [allRooms, setAllRooms] = useState([]);
  const [roomData, setRoomData] = useState([]);
  // const [admServer, setAdmnServer] = useState({});
  const [searchText, setSearchText] = useState("");
  const [game_code_internal, setGameCodeInternal] = useState("AllGames");
  const [activeState, setActiveState] = useState(null);
  // const [roomResult, setRoomResult] = useState({});
  const [onlineUserList, setOnlineUserList] = useState({});
  const [loading, setLoading] = useState(0);
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const storedPreference = localStorage.getItem("gridViewPreference");
  const initialView = storedPreference === "grid";
  const [gridView, setGridView] = useState(initialView);
  // const [onImgLoadCompleted, setOnImgLoadCompleted] = useState(false)
  // const [onImgLoadModel, setOnImgLoadModel] = useState(false)
  const [onImgLoadCompleted, setOnImgLoadCompleted] = useState(Array(roomData.length).fill(false));
  const [onImgLoadModel, setOnImgLoadModel] = useState(Array(roomData.length).fill(false));
  const [showBonus, setShowBonus] = useState(false);
  const currentStep = useSelector((state) => state.paginationData.currentStep)


  useEffect(() => {
    const timer = setTimeout(() => {
      setShowBonus(true);
    }, 21000);
    return () => clearTimeout(timer);

  }, []);
  const closeOnlinePopup = () => {
    setShowPopup(false);
    window.location.reload();
  };

  useEffect(() => {
    if (socket.connected) {
      tempLoading++;
      setLoading(tempLoading);
    }
    socket.on("connect", () => {
      tempLoading++;
      setLoading(tempLoading);
    });
    socket.on("disconnect", () => { });
    socket.on("error", (error) => { });
    socket.on("connect_error", (error) => { });
    socket.on("chat", (error) => { });
    let data = {
      room_id: "18",
    };
    socket.emit("game_history", data);
    // socket.on("game_history", (data) => { });
    socket.on("online_users", (response) => {
      if (response.length > 0) {
        let tempOnlineUsers = {};
        for (let key in response) {
          for (let innerKey in response[key]) {
            tempOnlineUsers[innerKey] = response[key][innerKey];
          }
        }
        setOnlineUserList(tempOnlineUsers);
      }
    });
    socket.emit("online_users");
    // setInterval(function () {
    //   socket.emit("online_users");
    // }, 10000);

    socket.emit("chat", { message: { text: "hi", username: "abcd" } });
  }, [socket]);

  // useEffect(() => {
  // }, [roomResult, loading]);

  const fetchListGame = () => {
    makeAjax(url.DINGDONG_API.listGameRoom).then((response) => {
      if (response.status !== respStatus["SUCCESS"]) {
        showMessage(response);
        return;
      }
      if (response.data.rooms.length === 0) {
        console.info("No card games available");
        navigate("/no-games");
        return;
      }
      const responseData = response;
      let tempRooms = [];
      for (let i = 0; i < response.data.rooms.length; i++) {
        let singleRoom = { ...response.data.rooms[i] };
        let min = 0;
        let max = 0;
        if (singleRoom.room_limit && singleRoom.room_limit.length > 0) {
          for (let j = 0; j < singleRoom.room_limit.length; j++) {
            if (singleRoom.room_limit[j].unit_list.length > 1) {
              if (min == 0) min = singleRoom.room_limit[j].unit_list[0].value;
              if (max == 0) max = singleRoom.room_limit[j].unit_list[1].value;
              min = Math.min(singleRoom.room_limit[j].unit_list[0].value, min);
              max = Math.max(singleRoom.room_limit[j].unit_list[1].value, max);
            }
          }
        }
        singleRoom.min = min;
        singleRoom.max = max;
        tempRooms.push(singleRoom);
      }
      const customGameOrder = [
        "Dingdong 48D New",
        "Dingdong 36D New",
        "Dingdong 24D New",
        "Dingdong 12D New",
        "Dingdong Sicbo New",
        "Dingdong Poker Dice New",
        "Dingdong Super Wheel",
        "Dingdong 48D",
        "Dingdong 36D",
        "Dingdong 24D",
        "Dingdong 12D",
        "Dingdong Sicbo",
        "Dingdong Poker Dice",
        "Dingdong Dragon Tiger",
      ];

      tempRooms.sort((a, b) => {
        const indexA = customGameOrder.indexOf(a.game_name);
        const indexB = customGameOrder.indexOf(b.game_name);
        return (indexA === -1 ? 999 : indexA) - (indexB === -1 ? 999 : indexB);
      });

      setAllRooms(tempRooms);
      // setAdmnServer(response.data.adm_server);
      tempLoading++;
      setLoading(tempLoading);

    });
  };
  // useEffect(() => {

  //   if (allRooms && onImgLoadCompleted && onImgLoadModel) {
  //     props.setLoginLobby(true)
  //   }

  //   setActiveState(null)

  // }, [onImgLoadCompleted, onImgLoadModel, allRooms])


  useEffect(() => {
    // Check if all elements in onImgLoadCompleted and onImgLoadModel are true
    const allImagesLoaded = onImgLoadCompleted.length === roomData.length && onImgLoadCompleted.every((status) => status === true);
    const allModelsLoaded = onImgLoadModel.length === roomData.length && onImgLoadModel.every((status) => status === true);

    // Proceed only if all rooms, images, and models are loaded
    if (roomData.length > 0 && allRooms && allImagesLoaded && allModelsLoaded) {
      props.setLoginLobby(true);
    }

    // Reset active state
    setActiveState(null); // Ensure setActiveState is defined in the component
  }, [onImgLoadCompleted, onImgLoadModel, allRooms, roomData.length]);


  const filterGame = () => {
    let filteredRooms = [...allRooms];
    //   if (game_code_internal != "AllGames" && game_code_internal != "MB")
    //     filteredRooms = filteredRooms.filter((singleRoom) =>
    //   singleRoom.game_code
    //   .toLowerCase()
    //   .includes(game_code_internal.toLowerCase())
    // );

    if (game_code_internal !== "AllGames" && game_code_internal !== "MB") {
      if (game_code_internal === "ARCADE") {
        filteredRooms = filteredRooms.filter((singleRoom) =>
          singleRoom.game_id >= 500 &&
          singleRoom.game_id <= 599
        );
      } else {
        filteredRooms = filteredRooms.filter((singleRoom) =>
          singleRoom.game_code
            .toLowerCase()
            .includes(game_code_internal.toLowerCase())
        );
      }
    }
    if (searchText != "")
      filteredRooms = filteredRooms.filter(
        (singleRoom) =>
          singleRoom.game_name
            .toLowerCase()
            .includes(searchText.toLowerCase()) ||
          singleRoom.room_name.toLowerCase().includes(searchText.toLowerCase())
      );
    setRoomData(filteredRooms);
  };





  useEffect(() => {
    filterGame();
  }, [allRooms, searchText, game_code_internal]);

  useEffect(() => {
    if (!game_code) {
      setGameCodeInternal("AllGames");
      return;
    }
    setGameCodeInternal(game_code);
  }, [game_code, showPopup]);

  useEffect(() => {
    fetchListGame();
    fetchUserDetail();
  }, []);

  const openedRooms = {};
  const launchRoom = async (room, room_limit) => {
    const fetchCheckGameStatus = () => {
      let reqData1 = {
        roomName: room.room_name,
        gameId: room.game_id,
      };

      makeAjax(url.DINGDONG_API.checkGameStatus, reqData1).then((response) => {
        if (response.status != respStatus["SUCCESS"]) {
          tempLoading++
          showMessage(response);
          fetchListGame();
          return;
        }
        let reqData = {
          roomName: room.room_name,
          gameId: room.game_id,
        };
        makeAjax(url.DINGDONG_API.getGameLink, reqData).then((response) => {
          if (response.status !== respStatus["SUCCESS"]) {
            setPopupMessage(response);
            // setShowPopup(true);
            return;
          }
          let url = response.data.link;
          const gameUrl = "/api/ddGame";
          const protocol = window.location.protocol;
          const domain = window.location.hostname;
          const orbit = localStorage.getItem("user_id");

          const homeUrl = response.data.home_url.replace(/\/api$/, '');
          let query_param = {
            orbit: orbit,
            game_id: room.game_id,
            limit_id: room_limit.id,
            game: room.game_code,
            room: room.room_name,
            limit: room_limit.limit_no,
            lang: user_profile.lang,
            // token: response.data.token,
            // operatorid: response.data.operatorid,
            // username: response.data.username,
            one_time_token: response.data.one_time_token,
            home_url: homeUrl
          };
          let param_string = Object.keys(query_param)
            .map(function (key) {
              return (
                encodeURIComponent(key) +
                "=" +
                encodeURIComponent(query_param[key])
              );
            })
            .join("&");
          url = url + gameUrl + "?" + param_string;
          const combinedKey = `${room.game_id}_${room_limit.id}`;
          if (device === "Desktop") {
            if (openedRooms[combinedKey] && !openedRooms[combinedKey].closed) {
              openedRooms[combinedKey].location.href = url;
            } else {
              const newWindow = window.open(url, "_blank");
              if (newWindow) { // Ensure newWindow is not null
                openedRooms[combinedKey] = newWindow;
                newWindow.onbeforeunload = () => {
                  delete openedRooms[combinedKey];
                };
              }
            }
          } else {
            window.open(url, "_self");
          }
        });
      });
    };
    fetchCheckGameStatus();
  };

  const handleSearchSubmit = (event) => {
    event.preventDefault();
    filterGame();
  };

  const handleTouch = (e, index) => {
    if (device === "Mobile") {
      setActiveState(index);
    }
  };

  const [userDetail, setUserDetail] = useState({});
  // api for userDetails
  const fetchUserDetail = () => {
    makeAjax(url.PLAYER_API.getUser, {}, url.PLAYER_MS_EXT).then((response) => {
      if (response.status != respStatus["SUCCESS"]) {
        showMessage(response);
        return;
      }
      localStorage.setItem("I18N_LANGUAGE", response.data.user.lang);
      setUserDetail(response.data.user);
    });
  };

  useEffect(() => {
    if (game_code_internal !== "AllGames") {
      setSearchText("");
    }
  }, [game_code_internal]);

  // Update local storage when user clicks the button
  const toggleView = () => {
    const newView = !gridView;
    setGridView(newView);
    localStorage.setItem("gridViewPreference", newView ? "grid" : "list");
  };

  useEffect(() => {
    // Update the grid view state based on the stored preference when component mounts
    if (storedPreference) {
      setGridView(storedPreference === "grid");
    }
  }, []);

  const handleOnLoadImg = (index) => {
    setOnImgLoadCompleted((prev) => {
      const updatedOnImgLoadCompleted = [...prev];
      updatedOnImgLoadCompleted[index] = true;
      return updatedOnImgLoadCompleted;
    });
  };

  const handleOnLoadImgModel = () => {

    setOnImgLoadModel(true)
  }

  // const handleOnLoadImg = (index) => {
  //   const newImageLoadStatus1 = [...imageLoadStatus1];
  //   newImageLoadStatus1[index] = true;
  //   setImageLoadStatus1(newImageLoadStatus1);
  //   if (newImageLoadStatus1.every(status => status)) {
  //     setOnImgLoadCompleted(true);
  //   }
  // };

  // const handleOnLoadImgModel = (index) => {
  //   const newImageLoadStatus2 = [...imageLoadStatus2];
  //   newImageLoadStatus2[index] = true;
  //   setImageLoadStatus2(newImageLoadStatus2);
  //   if (newImageLoadStatus2.every(status => status)) {
  //     setOnImgLoadModel(true);
  //   }
  // };
  const validGameCodes = ["AllGames", "48D", "36D", "24D", "12D", "SB", "DT", "PD", "WH", "MB", "ARCADE"];
  useEffect(() => {
    if (validGameCodes.includes(game_code)) {
      setGameCodeInternal(game_code);
    } else {
      navigate("/game/AllGames");
    }
  }, [game_code, navigate, validGameCodes]);


  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1024); // Adjust breakpoint as needed
    };

    handleResize(); // Check initial size
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);


  const handleCheckNewUser = () => {
    makeAjax(url.PLAYER_API.getCoachDetails, {}, url.PLAYER_MS_EXT)
      .then((response) => {
        if (response.status !== respStatus["SUCCESS"]) {
          showMessage(response);
          return;
        }
        if (response.data.value === 0) {
          dispatch(setCurrentStep(0))
        }
        else {
          dispatch(setCurrentStep(-1))

        }
      }).catch((error) => {
        console.error("Error fetching CoachMark status:", error);
      });
  }

  useEffect(() => {
    handleCheckNewUser()
  }, []);

  const gameGridRef = useRef();

  useEffect(() => {
    if (currentStep === (isMobile ? 3 : 8) && gameGridRef.current) {
      gameGridRef.current.scrollIntoView({
        behavior: "smooth", // Instant scrolling
        block: "end",   // Align the element to the top of the viewport
      });
    }

  }, [currentStep]);

  //  useEffect(() => {
  //   const PromoDirection = localStorage.getItem("PromoDirection");

  //   if (PromoDirection == 1 || window.location.pathname == '/') {
  //     handleClosePopup();
  //   }
  // }, []);

  return (
    <>
      {showBonus && <Bonus />}
      <div
        className={`card_container ${device === "Desktop" ? "desktop" : "mobile"
          }`}

      >
        <div className={`dashboard_main custom-tooltip-wrapper`} >
          <div className="dashboard_top_header" style={
            currentStep === 8
              ? { zIndex: 0 }
              : currentStep === 3 && isMobile
                ? { zIndex: 'auto' }
                : {}
          } ref={gameGridRef}>
            {/* 
              <div className='mo_allgame' onClick={() => { navigate("/allGames") }}><img src={allgame}></img></div>
                  <h2 className="dashboard_heading">{props.t(game_code_internal + '_label')}</h2>
             */}
            {device !== "Desktop" ? (
              game_code_internal === "AllGames" ? (
                <div
                  className={`mo_allgame custom-tooltip-wrapper ${currentStep === 0 ? "highlighted " : ""}`}
                  onClick={() => {
                    navigate("/allGames");
                  }}
                >
                  <img src={allgame} alt="allGame"></img>
                  {currentStep == 0 && <CoachMarkPopup />}
                </div>
              ) : (
                <div className="mo_pages_topbar">
                  <div
                    className="back_arrow"
                    onClick={() => navigate("/allGames")}
                  >
                    <img src={arrows} alt="backArrow"></img>
                  </div>
                  <div className="mo_page_heading">
                    <h2>
                      {props.t(game_code_internal + "_label", { defaultValue: gameHeading[game_code] })}
                    </h2>
                  </div>
                </div>
              )
            ) : (
              <>
                <div
                  className="mo_allgame"
                  onClick={() => {
                    navigate("/allGames");
                  }}
                >
                  <img src={allgame} alt="allGame"></img>
                </div>
                <h2 className="dashboard_heading">
                  {props.t(game_code_internal + "_label", { defaultValue: gameHeading[game_code] })}
                </h2>
              </>
            )}
            {currentStep === 0 && <div className="custom-overlay"></div>}

            {game_code_internal === "AllGames" ? (
              <div className="dashboard_header_right">
                <form onSubmit={handleSearchSubmit} >

                  <div className={`dashboard_search custom-tooltip-wrapper search-box  ${currentStep === (isMobile ? 1 : 9) ? "highlighted" : ""} `}>
                    <input
                      type="text"
                      value={searchText}
                      onChange={(event) => {
                        setSearchText(event.target.value);
                      }}
                      alt=""
                    />
                    <img src={SearchIcon} alt="" />
                    {currentStep === (isMobile ? 1 : 9) && <CoachMarkPopup />}

                  </div>
                </form>
                {currentStep === (isMobile ? 1 : 9) && <div className="custom-overlay" style={{ backgroundColor: "rgba(0, 0, 0, 0.6)" }}></div>}
                <div
                  className={`dashboard_gird_list_button custom-tooltip-wrapper ${currentStep === 2 ? "highlighted " : ""} ${currentStep === 10 ? "highlighted " : ""}`}
                  onClick={toggleView}
                >
                  <img src={gridView ? GirdIcon : ListIcon} alt="" />
                  {/* {currentStep == 10 &&  <CoachMarkPopup/>} */}
                  {currentStep === 10 && window.innerWidth > 1024 && <CoachMarkPopup />}

                  {isMobile && currentStep == 2 && <CoachMarkPopup />}

                </div>
                {currentStep === 2 && <div className="custom-overlay"></div>}
                {currentStep === 10 && <div className="custom-overlay" style={{ backgroundColor: "rgba(0, 0, 0, 0.6)" }}></div>}


              </div>
            ) : (
              ""
            )}
          </div>
          {currentStep === (isMobile ? 3 : 8) && <div className="custom-overlay" style={{
            backgroundColor: 'rgba(0, 0, 0, 0.6)',
          }}
          ></div>}
          <div
            className={`game_lists ${gridView && game_code_internal === "AllGames" ? "grid_view" : null
              }`}
          >
            {loading < 2 ? null : roomData.length > 0 ?
              (
                roomData.map((room, index) => {
                  return (
                    <div className="festive-game-items-div">
                      <div className="festiveTheme-game-img-placeholder" style={{
                        zIndex: currentStep === (isMobile ? 3 : 8) ? 1 : 5
                      }}>
                        <img src={FestiveThemeGameImg} alt="" />
                      </div>
                      <div className="newYear-game-img-placeholder " style={{
                        zIndex: isMobile
                          ? index === 0
                            ? [0, 1, 2, 4, 5, 6, 7, 8, 9, 10, 11].includes(currentStep)
                              ? 9 // Mobile: currentStep is in the range 1-9, zIndex is 9
                              : 10
                            : 1 // Mobile: index is not 0, zIndex is 1
                          : index === 0 && currentStep === 8
                            ? 6 // Desktop: index is 0 and currentStep is 8, zIndex is 6
                            : 1, // Desktop: Otherwise, zIndex is 1
                      }}>
                        <img src={device === "Mobile" ? NewYearThemeMobileImg : NewYearThemeImg} alt="" />
                      </div>
                      <div className="Ramadan-game-img-placeholder " style={{
                        zIndex: isMobile
                          ? index === 0
                            ? [0, 1, 2, 4, 5, 6, 7, 8, 9, 10, 11].includes(currentStep)
                              ? 9 // Mobile: currentStep is in the range 1-9, zIndex is 9
                              : 10
                            : 1 // Mobile: index is not 0, zIndex is 1
                          : index === 0 
                            ? 6 // Desktop: index is 0 and currentStep is 8, zIndex is 6
                            : 1, // Desktop: Otherwise, zIndex is 1
                      }}>
                        <img src={RamadanThemeImg} alt="" />
                      </div>
                      <div
                        className={`game_item  custom-tooltip-wrapper ${activeState === index ? "selected" : ""
                          } ${(currentStep === (isMobile && index === 0 ? 3 : 8)) ? "highlighted first-game full-opacity" : ""}`}
                        style={{
                          overflow: (currentStep === 8 && index === 0) || currentStep === 3 ? "visible" : "hidden",
                          zIndex:
                            index === 0
                              ? window.innerWidth <= 1024
                                ? currentStep === 0 || currentStep === 1 || currentStep === 2
                                  ? "auto"
                                  : 3
                                : currentStep === 0 || currentStep === 1 || currentStep === 2
                                  ? 9999999
                                  : "auto"
                              : "0",
                          // opacity: currentStep === (isMobile ? 3 : 8) ? 1 : "inherit",
                        }}
                        key={index}
                        // onClick={(e) => handleTouch(e, index)}
                        onTouchEnd={(e) => handleTouch(e, index)}
                      // onTouchEnd={() => setActiveState(null)}
                      >
                        {/* game limit design */}
                        {room.room_status === 2 || room.game_allowed === false ? (
                          <>
                            <div className="game_item maintenance" style={{ flexDirection: "column" }}  >
                              <div style={{ display: "flex" }}>
                                <img
                                  src={dummyimg}
                                  alt=""
                                  width={100}
                                  style={{ alignSelf: "center" }}
                                />
                                <p>{room.game_allowed === false ? 'Restricted' : 'Maintenance'} </p>
                              </div>

                              {room.game_allowed === false && (
                                <p style={{ fontSize: "12px", color: "#888", display: "block", marginTop: "4px" }}>
                                  {props.t('promotion_message') + ' ' + room.message}
                                </p>
                              )}
                            </div>
                          </>
                        ) : (
                          <></>
                          // <div className="game_limit_popup_container">
                          //    <div className="game_limit_popup">
                          //     <h5 className="game_limit_title">
                          //       {props.t("please_select_limit")}
                          //     </h5>
                          //     {room.room_limit.map((room_limit, inner_index) => {
                          //       return (
                          //         <p
                          //           onClick={() => {
                          //             launchRoom(room, room_limit);
                          //           }}
                          //           key={inner_index}
                          //           className="game_limit_amnt"
                          //         >
                          //           Limit :{" "}
                          //           {room_limit.unit_list[0].value.toLocaleString()}{" "}
                          //           -{" "}
                          //           {room_limit.unit_list[1].value.toLocaleString()}
                          //         </p>
                          //       );
                          //     })}
                          //   </div>
                          // </div>
                        )}
                        {/* game limit design */}
                        {(room.game_id >= 500 && room.game_id <= 599) && (
                          <div
                            className="game_play_btn_div"
                            onClick={() => handleLaunchGame(room, userName)}
                          >
                          </div>
                        )}
                        <div className="game_item_bg">
                          <img src={backgroundImage[room.game_code]} onLoad={() => handleOnLoadImg(index)} alt="" />
                        </div>
                        <div
                          className="game_item_content"
                          onClick={() => {
                            if (!(room.game_id >= 500 && room.game_id <= 599)) {
                              launchRoom(room, room.room_limit[0]);
                            }
                          }}
                          style={{
                            zIndex: currentStep === 8 ? 4 : "inherit",
                          }}
                        >
                          <div className="game_item_model">
                            <img
                              onLoad={() => handleOnLoadImgModel(index)}
                              src={
                                modelImageMappings[
                                `${gameLabel[room.game_code]
                                  ? gameLabel[room.game_code]
                                  : room.game_name
                                }-${room.room_name}`
                                ]
                              }
                              alt=""
                            />
                          </div>
                          <div className="game_item_header">
                            <div className="game_item_logo">
                              <img src={gameIcon[room.game_code]} alt="" />
                            </div>
                            <p className="game_item_title">
                              {gameLabel[room.game_code]
                                ? gameLabel[room.game_code]
                                : room.game_name}
                            </p>
                            <div className="game_type">{room.room_name}</div>
                          </div>
                          {/*game ding_dong detail start*/}
                          {renderSwitch(
                            resultTemplate[room.game_code],
                            room.game_code,
                            room.room_id
                          )}
                          {/*game ding_dong detail end*/}
                          <div className="game_item_footer">
                            <div className="amnt">
                              {room.room_limit.length > 0 ? (
                                <>
                                  <p className="game_min_limit">
                                    {userDetail.curr} {room.min.toLocaleString()}{" "}
                                  </p>
                                  <p className="game_max_limit">
                                    {" "}
                                    &nbsp;- {userDetail.curr}{" "}
                                    {room.max.toLocaleString()}
                                  </p>
                                </>
                              ) : (
                                ""
                              )}
                            </div>
                            {room.room_status === 2 ? (
                              <div className="total_users">
                                <img src={UserIcon} alt="" />
                                0
                              </div>
                            ) : (
                              <div className="total_users">
                                <img src={UserIcon} alt="" />
                                {onlineUserList[room.room_id]
                                  ? onlineUserList[room.room_id]
                                  : 0}
                              </div>
                            )}
                          </div>
                        </div>

                        {currentStep == (isMobile && index == 0 ? 3 : 8) && <CoachMarkPopup />}
                      </div>
                      {/* {currentStep == 8 && <CoachMarkPopup/>} */}



                    </div>

                  );
                })
              ) : (
                <div className="game_no_data_found">{props.t("data_not_found")}</div>
              )}
          </div>
          {currentStep === (isMobile ? 3 : 8) && <div className="custom-overlay" style={{
      zIndex: isMobile && currentStep === 3 ? 2 : undefined,
    }}
          ></div>}

          {currentStep === 11 && activeState === "MB" && <CoachMarkPopup />}
        </div>

        {/* {currentStep &&  <div id="coachmark11"> <CoachMarkPopup /></div>} */}
        {/* {currentStep === 11 && activeState === "MB" && <div id="coachmark11"> <CoachMarkPopup /></div>} */}

      </div>

      {showIframe && (
        <IframeLauncher
          gameUrl={iframeUrl}
          onClose={handleCloseIframe}
        />
      )}

      {showPopup && (
        <>
          <div
            className="game_status_popup_overlay"
            onClick={closeOnlinePopup}
          ></div>
          <div className="game_status_popup">
            <button
              onClick={closeOnlinePopup}
              className="game_status_popup_close"
            >
              <img src={CloseIcon} alt="" />
            </button>
            <div className="game_status_popup_body ">
              <h3>{popupMessage}</h3>
            </div>
          </div>
        </>
      )}

      {showPromoPopup && (
        <>
          <div
            className="game_status_popup_overlay"
            onClick={() => {
              handleClosePopup();
              doNotShowChange();
            }}
          ></div>
          <div className="game_status_popup">
            <button
              onClick={() => {
                handleClosePopup();
                doNotShowChange();
              }}
              className="game_status_popup_close"
            >
              <img src={CloseIcon} alt="" />
            </button>
            <div className="game_status_popup_body ">
              <img src={bannerImg} alt="Promotion Banner" onClick={handleBannerClick} />
            </div>
            <div className="game_status_popup_footer">
              <label className="do_not_show_checkbox">
                <input
                  type="checkbox"
                  id={bannerId}
                  checked={doNotShowAgain}
                  onChange={(e) => doNotChecked(e)}
                />
                Do not show this again
              </label>
            </div>
          </div>

        </>
      )}
      {showPromotion && (
        <div className="promotion_popup_overlay">
          <div className="promotion_popup">
            <button onClick={() => setShowPromotion(false)}>Close</button>
            <Promotion
              onClose={() => setShowPromotion(false)}
              idBanner={selectedBanner}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default withTranslation()(LobbyContent);
